export const isDigit = c => c >= '0' && c <= '9';